export default {
	"planMapComp": {
		"showLocal": "显示地标",
		"multipleSelectionAddress": "请人工定位以下地址列表",
		"defectAddressGps": "缺失坐标地址",
		"supplement": "补充",
		"timeWindows": "时间窗",
		"allDay": "全天",
		"huoliang": "货量",
		"dan": "单",
		"gong": "共",
		"errMsg": "计划失败原因如下",
		"start": "起",
		"more": "多",
		"jihua": "计划",
		"daoda": "到达",
		"likai": "离开",
		"xinxiDialog": "信息窗口",
		"xiuzheng": "修正定位",
		"peisong": "配送",
		"dian": "个点",
		"btnCreateRoute": "生成派车单",
		"aiPaixian": "智能排线",
		"selectRouterTips": "请选择运单",
		"rangeValueTips1": "范围距离必须为正值",
		"rangeValueTips2": "范围距离只能输入数字",
		"noTransports": "没有试算出线路",
		"none": "无"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/planMapComp/planMapComp.js